import { isNullOrUndefined } from 'utils/validation';

export const validateContractHours = (value: number | string | undefined): boolean => {
    if (isNullOrUndefined(value) || value === '' || Number.isNaN(value) || Number.isNaN(Number(value)) || Number(value) < 0) {
        return false;
    }

    return true;
};
